// Action types for fetching data
export const FETCH_ALL_ADDRESSES_REQUEST = 'FETCH_ALL_ADDRESSES_REQUEST';
export const FETCH_ALL_ADDRESSES_SUCCESS = 'FETCH_ALL_ADDRESSES_SUCCESS';
export const FETCH_ALL_ADDRESSES_FAILURE = 'FETCH_ALL_ADDRESSES_FAILURE';
// Fetch data actions
export const fetchAllAddressesRequest = () => ({
    type: FETCH_ALL_ADDRESSES_REQUEST,
});
export const fetchAllAddressesSuccess = (payload) => ({
    type: FETCH_ALL_ADDRESSES_SUCCESS,
    payload,
});
export const fetchAllAddressesFailure = (error) => ({
    type: FETCH_ALL_ADDRESSES_FAILURE,
    payload: error,
});
